export default {
  data() {
    return {
      // Validação comum - padrão, chamar apenas uma sem []
      nameRules: [
        (v) => !!v || "Nome é obrigatório",
        (v) => (v && v.length <= 40) || "Name must be less than 40 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail é necessário",
        (v) => /.+@.+\..+/.test(v) || "E-mail deve ser válido",
      ],
      required: [(v) => !!v || "Campo obrigatório"],
      required_multiple: [(v) => !!v.length || "Campo obrigatório"],
      required_url: [
        (v) => (
          /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i.test(v)
          || 'Url deve ser válida'
        )
      ],
      password_complexity: [
        (v) => (!!v && v.length >= 8) || "Min 8 caracteres",
        (v) => (/[A-Z]/.test(v))|| "A senha deve conter pelo menos uma letra maiúscula",
        (v) => (/[a-z]/.test(v))|| "A senha deve conter pelo menos uma letra minúscula",
        (v) => (/\d/.test(v)) || "A senha deve conter pelo menos um número",
        (v) => (/\W/.test(v)) || "A senha deve conter pelo menos um caracter especial",
        (v) => (!/\s/.test(v)) || "A senha não pode conter espaços"]
    };
  },
  methods: {
    // Validação individual, chamar muliplas dentro de [method(), method(param)]
    ruleRequired(msg) {
      return (v) => !!v || msg;
    },
    ruleMaxInteger(max) {
      return (v) => (!!v && parseInt(v) <= parseInt(max)) || (("Máx " + max) );
    },
    ruleMail() {
      return (v) => (/.+@.+\..+/.test(v) || !v) || "E-mail inválido";
    },
    ruleMaxLen(max, kind) {
      return (v) => (v && v.length <= max) || "Máx " + max + " " + (kind||'caracteres');
    },
    ruleMinLen(min, kind) {
      return (v) => (v && v.length >= min) || "Min " + min + " " + (kind||'caracteres');
    },
    ruleMatch(value2Match) {
      return (v) => (v && v == value2Match) || "Não combina";
    },
    ruleMinNumber(min, kind) {
      return (v) => (v && Number(v.match(/\d+/g).join('')) >= min) || "Min " + min + " " ;
    },
    ruleMaxNumber(min, kind) {
      return (v) => (v && Number(v.match(/\d+/g).join('')) >= min) || "Máx " + min + " ";
    },
  },
};
